/** Base viewport height for scaling reference (iPhone standard). */
const BASE_HEIGHT = 812;

/** Minimum scale factor to prevent over-compression. */
const MIN_SCALE = 0.65;

/** Pixel values that get scaled via `--vs-{N}` CSS custom properties. */
export const VSCALE_VALUES = [
  4, 8, 11, 14, 15, 16, 17, 20, 24, 27, 30, 35, 36, 44, 47, 54, 55, 168,
] as const;

/**
 * Computes a 0.65–1.0 vertical scale factor from viewport height.
 * Mirrors the React Native `vScale(height)` utility (base 812px).
 */
export function computeVScale(viewportHeight: number): number {
  return Math.min(1, Math.max(MIN_SCALE, viewportHeight / BASE_HEIGHT));
}

/**
 * Builds a `--vs-{N}` CSS variable map from a scale factor.
 * Apply to a container's `style` prop; children reference via `var(--vs-47, 47px)`.
 */
export function buildVScaleVars(vs: number): Record<string, string> {
  const vars: Record<string, string> = {};
  for (const px of VSCALE_VALUES) {
    vars[`--vs-${px}`] = `${Math.round(px * vs)}px`;
  }
  return vars;
}
